import React, {useEffect, useRef} from 'react';
import {useField} from '@unform/core';
import InputMask from 'react-input-mask';

const UInputMask = (props) => {
    const {
        name,
        label,
        disabled,
        mask,
        id,
    } = props;
    const inputRef = useRef(null);
    const {fieldName, defaultValue, registerField, error} = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [registerField, fieldName]);


    return (
        <>
            {label && <label htmlFor={fieldName}>{label}</label>}

            <InputMask
                ref={inputRef}
                name={name}
                id={id}
                disabled={disabled}
                className={'form-control'}
                mask={mask}
                defaultValue={defaultValue}
            />

            {error && <span>{error}</span>}
        </>
    );
};

export default UInputMask;
